import { render, staticRenderFns } from "./IrregularTransactions.vue?vue&type=template&id=063a03c6&scoped=true&"
import script from "./IrregularTransactions.vue?vue&type=script&lang=js&"
export * from "./IrregularTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a03c6",
  null
  
)

export default component.exports